import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex justify-start items-center" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "relative rounded-lg" }
const _hoisted_6 = {
  class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_8 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_9 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_10 = { class: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl" }
const _hoisted_11 = { class: "px-4 sm:px-6" }
const _hoisted_12 = { class: "flex items-start justify-between" }
const _hoisted_13 = { class: "relative mt-6 flex-1 px-4 sm:px-6" }
const _hoisted_14 = { class: "h-full flex flex-col" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "mt-auto w-full" }
const _hoisted_17 = { class: "flex justify-end" }

import {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import {
    XMarkIcon,
    FunnelIcon,
    ArrowPathIcon,
    MagnifyingGlassIcon,
} from "@heroicons/vue/24/outline";
import ButtonComponent from "@/components/ButtonComponent.vue";

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterComponent',
  props: {
    textFilters: {
        type: Boolean,
        default: true,
    },
    rightButtonItems: {
        type: Boolean,
        default: false,
    },
    customFilters: {
        type: Boolean,
        default: true,
    },
    sidebarFilters: {
        type: Boolean,
        default: true,
    },
    buttonItems: {
        type: Boolean,
        default: false,
    },
    search: {
        type: String,
        default: null,
    },
},
  emits: ["fetchData", "update:filters"],
  setup(__props, { emit: __emit }) {

const props = __props;

const open = ref(false);
const searchText = ref(props.search);

const emit = __emit

const updateSearchText = (value) => {
    searchText.value = value;
    emit("fetchData", value);
}

const applyFilter = () => {
    open.value = false
    emit("update:filters");
}

const refresh = () => {
    location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.customFilters)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.sidebarFilters)
                ? (_openBlock(), _createBlock(ButtonComponent, {
                    key: 0,
                    type: "button",
                    secondary: "",
                    class: "mr-2 h-10",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FunnelIcon), {
                        class: "-ml-0.5 mr-2 h-4 w-4",
                        "aria-hidden": "true"
                      }),
                      _cache[6] || (_cache[6] = _createTextVNode(" Filter ", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.buttonItems)
                ? _renderSlot(_ctx.$slots, "buttons", { key: 1 })
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(ButtonComponent, {
          type: "button",
          secondary: "",
          class: "h-10",
          onClick: refresh
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowPathIcon), {
              class: "-ml-0.5 h-4 w-4",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.textFilters)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "search",
                class: "sr-only"
              }, "Search", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(MagnifyingGlassIcon), {
                    class: "mr-3 h-5 w-5 text-gray-600",
                    "aria-hidden": "true"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                  type: "text",
                  name: "search",
                  id: "search",
                  class: "focus:ring-primary-300 focus:border-primary-300 block w-full pl-10 text-sm border-gray-300 rounded-lg h-11",
                  placeholder: "Search",
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (updateSearchText($event.target.value)))
                }, null, 544), [
                  [_vModelText, searchText.value]
                ]),
                (searchText.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (updateSearchText(null))),
                      class: "absolute inset-y-0 right-0 pr-3 flex items-center z-10"
                    }, [
                      _createVNode(_unref(XMarkIcon), {
                        class: "h-5 w-5 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.rightButtonItems)
          ? _renderSlot(_ctx.$slots, "rightButtons", { key: 1 })
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: open.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (open.value = false))
        }, {
          default: _withCtx(() => [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fixed inset-0" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-500 sm:duration-700",
                    "enter-from": "translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-500 sm:duration-700",
                    "leave-from": "translate-x-0",
                    "leave-to": "translate-x-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "pointer-events-auto w-screen max-w-sm" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_unref(DialogTitle), { class: "text-lg font-medium text-gray-900" }, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode(" Filter ", -1)
                                  ]))]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _renderSlot(_ctx.$slots, "fields")
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(ButtonComponent, {
                                      secondary: "",
                                      class: "mr-2",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (open.value = false))
                                    }, {
                                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode(" Cancel ", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createVNode(ButtonComponent, {
                                      type: "button",
                                      onClick: applyFilter
                                    }, {
                                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode(" Apply Filter ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"])
  ]))
}
}

})